import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { createGLightbox, openGLightbox } from './lib/glightbox';

gsap.registerPlugin(ScrollTrigger);

const fly_plp: LegacyModule = {
	is_px_init: false,
	is_px_actv: false,
	bp: 1025,

	init: function () {
		this.cache();
		if (window.innerWidth >= this.bp) {
			this.init_parallaxes();
		}
		this.events();
		this.eco_modal();
	},
	cache: function () {
		this.$sctn_pairs = document.querySelectorAll('.plp-sctn-pair');
		this.$sctn_pairs_h = document.querySelectorAll('.plp-sctn-pair-h');
		this.$sctn_v_drift = document.querySelectorAll('.sctn-v-drift');
		this.$sctn_r_drift = document.querySelectorAll('.sctn-r-drift');
		this.$sctn_anim_trigger = document.querySelectorAll('.sctn-anim-trigger');

		this.$sctn_app = document.getElementById('plp-sctn-xl-app');
		this.$sctn_light = document.getElementById('plp-sctn-xl-lightweight');
		this.$sctn_eco2 = document.getElementById('plp-sctn-xl-ecosystem-2');
		this.$sctn_mimic = document.getElementById('plp-sctn-xl-mimic');
		//this.$sctn_eco_map 		= document.getElementById('plp-sctn-xl-ecosystem-2');
		//this.$icons_eco_map		= document.querySelectorAll('#plp-sctn-xl-ecosystem-2 .icon');
		//this.$overlays_eco_map	= document.querySelectorAll('#plp-sctn-xl-ecosystem-2 .overlay');
		this.$sctn_modular_map = document.getElementById('plp-sctn-xl-modular');
		this.$pins_modular_map = document.querySelectorAll('#plp-sctn-xl-modular .pin');
	},

	init_parallaxes: function () {
		this.is_px_init = true;
		this.is_px_actv = true;

		this.hero_parallax();

		if (this.$sctn_pairs.length > 0) {
			for (var i = 0; i < this.$sctn_pairs.length; i++) {
				this.pair_allax(this.$sctn_pairs[i]);
			}
		}

		if (this.$sctn_anim_trigger.length > 0) {
			for (var j = 0; j < this.$sctn_anim_trigger.length; j++) {
				this.init_anim_trig(this.$sctn_anim_trigger[j]);
			}
		}
		if (this.$sctn_v_drift.length > 0) {
			for (var k = 0; k < this.$sctn_v_drift.length; k++) {
				this.init_v_drift(this.$sctn_v_drift[k]);
			}
		}
		if (this.$sctn_pairs_h.length > 0) {
			for (var l = 0; l < this.$sctn_pairs_h.length; l++) {
				this.pair_allax_h(this.$sctn_pairs_h[l]);
			}
		}
		if (this.$sctn_r_drift.length > 0) {
			for (var m = 0; m < this.$sctn_r_drift.length; m++) {
				this.init_r_drift(this.$sctn_r_drift[m]);
			}
		}

		if (this.$sctn_app) {
			this.app_parallax();
		}
		if (this.$sctn_light) {
			this.lightweight_parallax(this.$sctn_light);
		}
		if (this.$sctn_eco2) {
			this.icon_parallax(this.$sctn_eco2);
		}
		if (this.$sctn_mimic) {
			this.mimic_parallax(this.$sctn_mimic);
		}
	},

	events: function () {
		// if( this.$icons_eco_map.length > 0 ){
		// 	for( var i = 0; i<this.$icons_eco_map.length; i++ ){
		// 		this.$icons_eco_map[i].addEventListener( 'mouseenter', this.show_eco_overlay.bind(this) );
		// 		this.$icons_eco_map[i].addEventListener( 'click', this.show_eco_overlay.bind(this) );
		// 		this.$icons_eco_map[i].addEventListener( 'mouseleave', this.hide_eco_overlay.bind(this) );
		// 	}
		// }

		if (this.$sctn_modular_map) {
			for (var j = 0; j < this.$pins_modular_map.length; j++) {
				this.$pins_modular_map[j].addEventListener('click', this.toggle_modular_pin.bind(this));
			}
		}

		window.addEventListener('optimizedResize', this.check_parallax.bind(this));
	},

	check_parallax: function () {
		var w = window.innerWidth;

		if (w >= this.bp) {
			if (!this.is_px_init) {
				this.init_parallaxes();
			} else {
				//this.update_parallax();
			}
		} else if (w < this.bp && this.is_px_init) {
			this.is_px_init = false;
			ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
		}
	},

	hero_parallax: function () {
		var $centered_pages = document.querySelectorAll(
			'#wrap-plp-xl-reliable, #wrap-plp-xl-versatile, #wrap-plp-pilot-modular'
		);
		var bg_left = $centered_pages.length > 0 ? '50%' : 0;

		const heroTimeline = gsap.timeline({
			scrollTrigger: {
				trigger: '.hero-plp',
				start: 0,
				end: `+=${document.querySelector('.hero-plp').clientHeight}`,
				scrub: true,
			},
		});
		heroTimeline.fromTo(
			'.hero-plp',
			{ duration: 1, backgroundPosition: bg_left + ' 134px' },
			{ backgroundPosition: bg_left + ' -16px' },
			0
		);
		heroTimeline.fromTo('.hero-plp .overlay', { duration: 1, opacity: 0 }, { opacity: 1 }, 0);
	},

	app_parallax: function () {
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: '#plp-sctn-xl-app',
				start: 'top 120%',
				end: `+=${window.innerHeight + document.querySelector('#plp-sctn-xl-app').clientHeight}`,
				scrub: true,
			},
		});
		tl.fromTo('#plp-sctn-xl-app .shadow', { duration: 1, opacity: -4 }, { opacity: 1 }, 0);
		tl.fromTo('#plp-sctn-xl-app .phone', { duration: 1, y: -70, x: 70 }, { y: 0, x: 0 }, 0);
	},

	lightweight_parallax: function ($sctn) {
		var $shadow = $sctn.querySelector('.img-shadow');
		var $xl = $sctn.querySelector('.img-xl');

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: $sctn,
				start: `top 75%`,
				end: `+=${0.5 * window.innerHeight + $sctn.clientHeight}`,
				scrub: true,
			},
		});
		tl.fromTo($shadow, { opacity: -4, duration: 1 }, { opacity: 1 }, 0);
		tl.fromTo($xl, { y: -70, duration: 1 }, { y: 0 }, 0);
	},

	pair_allax: function ($sctn) {
		var $img_l = $sctn.querySelector('.img-l');
		var $img_r = $sctn.querySelector('.img-r');

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: $sctn,
				start: `top 75%`,
				end: `+=${window.innerHeight + $sctn.clientHeight}`,
				scrub: true,
			},
		});
		if ($img_l) tl.fromTo($img_l, { y: -70, x: -70, duration: 1 }, { y: 0, x: 0 }, 0);
		if ($img_r) tl.fromTo($img_r, { y: -70, x: 70, duration: 1 }, { y: 0, x: 0 }, 0);
	},

	pair_allax_h: function ($sctn) {
		var $img_l = $sctn.querySelector('.img-l');
		var $img_r = $sctn.querySelector('.img-r');

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: $sctn,
				start: `top 75%`,
				end: `+=${window.innerHeight + $sctn.clientHeight}`,
				scrub: true,
			},
		});
		tl.fromTo($img_l, { x: -70, duration: 1 }, { x: 0 });
		tl.fromTo($img_r, { x: 70, duration: 1 }, { x: 0 }, 0);
	},

	init_anim_trig: function ($sctn) {
		ScrollTrigger.create({
			trigger: $sctn,
			start: 'top top',
			onToggle: (e) => {
				if (e.isActive) {
					$sctn.classList.add('active');
				} else {
					$sctn.classList.remove('active');
				}
			},
		});
	},

	init_v_drift: function ($sctn) {
		var $img = $sctn.querySelector('.img-drift');

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: $sctn,
				start: `top 75%`,
				end: `+=${window.innerHeight}`,
				scrub: true,
			},
		});
		tl.fromTo($img, { duration: 1, y: -70 }, { y: 0 });
	},

	init_r_drift: function ($sctn) {
		var $img = $sctn.querySelector('.img-drift');

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: $sctn,
				start: `top 75%`,
				end: `+=${window.innerHeight}`,
				scrub: true,
			},
		});
		tl.fromTo($img, { duration: 1, x: -120, opacity: 0 }, { x: 0, opacity: 1 });
	},

	icon_parallax: function ($sctn) {
		var $icon_1 = $sctn.querySelector('.icon-1');
		var $icon_2 = $sctn.querySelector('.icon-2');
		var $icon_3 = $sctn.querySelector('.icon-3');
		var $overlay = $sctn.querySelector('#overlay-all');

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: $sctn,
				start: `top 50%`,
				end: `+=${0.5 * window.innerHeight}`,
			},
		});
		tl.fromTo($icon_1, { duration: 1, opacity: 0, x: -70 }, { opacity: 1, x: 0 }, 0);
		tl.fromTo($icon_2, { duration: 1, opacity: 0, x: -70 }, { opacity: 1, x: 0, delay: 0.2 }, 0);
		tl.fromTo($icon_3, { duration: 1, opacity: 0, x: -70 }, { opacity: 1, x: 0, delay: 0.4 }, 0);
		tl.fromTo($overlay, { duration: 1, opacity: 0 }, { opacity: 1, delay: 0.7 }, 0);
	},

	mimic_parallax: function ($sctn) {
		var $img_l = $sctn.querySelector('.img-xl');
		var $img_r = $sctn.querySelector('.img-mimic');

		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: $sctn,
				start: `top 75%`,
				end: `+=${window.innerHeight}`,
				scrub: true,
			},
		});
		tl.fromTo($img_l, { duration: 1, y: -200 }, { y: 0 }, 0);
		tl.fromTo($img_r, { duration: 1, y: -70 }, { y: 0 }, 0);
	},

	// show_eco_overlay: function(e){
	// 	var slug =  e.currentTarget.getAttribute('data-overlay');
	// 	this.$sctn_eco_map.querySelector('#overlay-' + slug).style.opacity = 1;
	// },
	// hide_eco_overlay: function(e){
	// 	for( var i = 0; i<this.$overlays_eco_map.length; i++ ){
	// 		this.$overlays_eco_map[i].removeAttribute('style');
	// 	}
	// },

	toggle_modular_pin: function (e) {
		var $targ = e.currentTarget;

		if ($targ.classList.contains('ff-active')) {
			$targ.classList.remove('ff-active');
		} else {
			for (var i = 0; i < this.$pins_modular_map.length; i++) {
				this.$pins_modular_map[i].classList.remove('ff-active');
			}
			$targ.classList.add('ff-active');
		}
	},
	eco_modal: function () {
		const ecoModalOptions = {
			skin: 'ff-modal-eco',
			width: 'auto',
			height: 'auto',
			draggable: false,
			touchNavigation: false,
		};

		createGLightbox({
			selector: '.ff-js-modal-img-dt',
			...ecoModalOptions,
		});

		if (window.location.href.indexOf('#ecosystem') > -1) {
			openGLightbox([{ href: '#ff-modal-content-eco', type: 'inline' }], ecoModalOptions);
		}
	},
};

fly_plp.init();
